<!-- 下注动态 -->
<template>
<div class="cont-row join-trends">
    <div class="cont">下注动态：</div>
    <div class="flex-cont" v-if="pageLoading">
        <swiper :options="swiperOptions">
            <swiper-slide v-for="(item,index) in list" :key="index">
            <div class="info">{{item.msg}}</div>
            </swiper-slide>
        </swiper>
    </div>
</div>
</template>
<script>
export default {
    name:'JoinTrends',
    data(){
        return  {
            pageLoading:false,
            // 轮播图配置
            swiperOptions: {
                direction:'vertical',
                //spaceBetween: 30,
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                
            
                /* pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                }, */
            },
            list:[
                '王二麻子参与巴西VS阿根廷下注',
                '刘全参与巴西VS阿根廷下注',
                '王贵参与巴西VS阿根廷下注',
                '张三参与巴西VS阿根廷下注',
                '李四参与巴西VS阿根廷下注',
                '张顺参与巴西VS阿根廷下注',
            ]
        }
    },
    created(){
        this.getList();
    },
    methods:{
        async  getList(){
            
            let result = await this.$axios.get('/worldcup2022/game/coin/latest/stake/tips')
            this.pageLoading = true
            console.log('下注动态====》',result);
            if( result.code == 0 ){
                this.list = result.data.tips;
            }
        }
    }
}
</script>
<style lang="less" scoped>
.join-trends{
    background: #FEDE86; padding: 20px 50px; font-size: 17px; line-height: 24px; color: #3f3f3f; margin: 20px auto; border-radius: 10px;
    .flex-cont{height: 24px; overflow: hidden;}
}
@media screen and (max-width:768px){
    .join-trends{
        display: none;
    }

}
</style>